"use client"

import { appVersion } from "@/lib/version"
import Link from "next/link"
import { Logo } from "./logo"
import { SocialLinks } from "./social-links"


export function PublicFooter() {
  return (
    <footer className="bg-gray-900 dark:bg-[#0A0A0A] py-8 text-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Link
            href="/"
            className="flex items-center space-x-2 mb-4 md:mb-0"
            data-analytics-category="PUBLIC_NAV"
            data-analytics-action="CLICK"
            data-analytics-name="FOOTER_HOME_LOGO"
          >
            <Logo />
            <span className="font-bold">The HIIT PIT</span>
          </Link>

          <div className="flex space-x-6">
            <Link
              href="/"
              className="text-gray-400 hover:text-white transition-colors"
              data-analytics-category="PUBLIC_NAV"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_HOME"
            >
              Home
            </Link>
            <Link
              href="/faq"
              className="text-gray-400 hover:text-white transition-colors"
              data-analytics-category="PUBLIC_NAV"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_FAQ"
            >
              FAQ
            </Link>
            <Link
              href="/hiit"
              className="text-gray-400 hover:text-white transition-colors"
              data-analytics-category="PUBLIC_NAV"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_ABOUT_HIIT"
            >
              About HIIT
            </Link>
            <Link
              href="/sign-in"
              className="text-gray-400 hover:text-white transition-colors"
              data-analytics-category="CTA_ENGAGEMENT"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_SIGN_IN"
            >
              Sign In
            </Link>
            <Link
              href="/sign-up"
              className="text-gray-400 hover:text-white transition-colors"
              data-analytics-category="CTA_ENGAGEMENT"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_SIGN_UP"
            >
              Sign Up
            </Link>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-3">
            <p className="text-sm text-gray-400">Join our community</p>
            <SocialLinks linkedin bsky reddit />
          </div>
        </div>

        <div className="mt-4 text-center text-gray-500 text-sm">
          &copy;{" "}
          <a
            href="https://regalbrains.com"
            target="_blank"
            rel="noreferrer noopener"
            className="hover:text-gray-300 transition-colors"
            data-analytics-category="OUTBOUND_LINK"
            data-analytics-action="CLICK"
            data-analytics-name="FOOTER_REGAL_BRAINS"
          >
            Regal Brains, LLC
          </a>{" "}
          2025. All rights reserved.
          <div className="mt-2 text-[12px] text-gray-600 dark:text-gray-700 flex justify-center space-x-3">
            <a
              href="/sitemap.xml"
              className="hover:text-gray-400 transition-colors"
              aria-label="View sitemap"
              data-analytics-category="UTILITY"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_SITEMAP"
            >
              Sitemap
            </a>
            <a
              href="/llm.txt"
              className="hover:text-gray-400 transition-colors"
              aria-label="View LLM guidelines"
              data-analytics-category="UTILITY"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_LLM"
            >
              LLM
            </a>
            <Link
              href="/terms"
              className="hover:text-gray-400 transition-colors"
              data-analytics-category="PUBLIC_NAV"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_TERMS"
            >
              Terms
            </Link>
            <Link
              href="/privacy"
              className="hover:text-gray-400 transition-colors"
              data-analytics-category="PUBLIC_NAV"
              data-analytics-action="CLICK"
              data-analytics-name="FOOTER_PRIVACY"
            >
              Privacy
            </Link>
            <span className="hover:text-gray-400 transition-colors">v{appVersion}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
